export class AnimationLoop {
    private animFrameId: number | null = null
    private loopCallback: (() => Promise<void> | void) | null = null
    private _isRunning: boolean = false

    public get isRunning(): boolean {
        return this._isRunning
    }

    private async executeFrame(): Promise<void> {
        if (!this._isRunning || !this.loopCallback) {
            // Stop condition met (either _isRunning is false or callback is missing)
            // If _isRunning became false, stop() would have cleared animFrameId.
            return
        }

        try {
            await this.loopCallback()
        } catch (error) {
            console.error('Error in animation loop callback:', error)
            // Depending on desired behavior, you might want to stop the loop here:
            // this.stop();
        }

        // Only request the next frame if the loop is still marked as running
        // after the callback has completed. The callback itself (or another process)
        // might have called stop().
        if (this._isRunning) {
            this.animFrameId = requestAnimationFrame(() => this.executeFrame())
        }
    }

    public start(callback: () => Promise<void> | void): void {
        if (this._isRunning) {
            console.warn('AnimationLoop.start called while already running.')
            return
        }
        this.loopCallback = callback
        this._isRunning = true
        // Ensure any previous frame ID is cleared before starting a new one
        if (this.animFrameId !== null) {
            cancelAnimationFrame(this.animFrameId)
        }
        this.animFrameId = requestAnimationFrame(() => this.executeFrame())
    }

    public stop(): void {
        this._isRunning = false // Signal to stop processing/queueing new frames
        if (this.animFrameId !== null) {
            cancelAnimationFrame(this.animFrameId)
            this.animFrameId = null
        }
        this.loopCallback = null // Clear the callback when stopped
    }

    public dispose(): void {
        this.stop()
    }
}
